import React, { Component, Fragment } from 'react';
import { Layout, Typography, Button, Row, Col, Card, Table, Pagination, Input, Select, Space, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import AdminPortalHeader from '../../components/common/admin_portal_header';
import { getPaymentsForAdmin } from '../../api/pets-api';
import moment from 'moment';

const { Paragraph, Title } = Typography;
const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

class AdminPayments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payments: [],
            currentPage: 1,
            pageSize: 20,
            totalRecs: 0,
            selectedStatus: '',
            selectedAge: 'within7days',
            selectedPaymentChannel: '',
            searchEmail: '',
            loading: false,
        };
    }

    getPayments = async () => {
        this.setState({ loading: true });
        try {
            const params = {
                page: this.state.currentPage,
                pageSize: this.state.pageSize,
                age: this.state.selectedAge,
            };

            // Add optional filters only if they have values
            if (this.state.selectedStatus) {
                params.status = this.state.selectedStatus;
            }
            if (this.state.searchEmail) {
                params.email = this.state.searchEmail;
            }
            if (this.state.selectedPaymentChannel) {
                params.paymentChannel = this.state.selectedPaymentChannel;
            }

            let respo = await getPaymentsForAdmin(params);
            console.log(respo);

            if (respo.status === 200 && respo.data.status === 'ok') {
                const { payments, total } = respo.data.result;
                this.setState({
                    payments: payments || [],
                    totalRecs: total || 0,
                });
            } else {
                this.setState({ payments: [], totalRecs: 0 });
            }
        } catch (ex) {
            console.error('Error fetching payments:', ex);
            this.setState({ payments: [], totalRecs: 0 });
        } finally {
            this.setState({ loading: false });
        }
    };

    onPaginationChange = async (pageNumber) => {
        await this.setState({ currentPage: pageNumber });
        await this.getPayments();
    };

    showTotal = (total) => {
        return `Total ${total} Records`;
    };

    onStatusChange = async (value) => {
        await this.setState({ selectedStatus: value, currentPage: 1 });
        await this.getPayments();
    };

    onAgeChange = async (value) => {
        await this.setState({ selectedAge: value, currentPage: 1 });
        await this.getPayments();
    };

    onPaymentChannelChange = async (value) => {
        await this.setState({ selectedPaymentChannel: value, currentPage: 1 });
        await this.getPayments();
    };

    onSearchEmail = async (value) => {
        await this.setState({ searchEmail: value, currentPage: 1 });
        await this.getPayments();
    };

    onClearFilters = async () => {
        await this.setState({
            selectedStatus: '',
            selectedAge: 'within7days',
            selectedPaymentChannel: '',
            searchEmail: '',
            currentPage: 1,
        });
        await this.getPayments();
    };

    async componentDidMount() {
        await this.getPayments();
    }

    navigateToPayment(paymentId) {
        console.log('Payment ID', paymentId);
        window.location.pathname = '/admin_payments/' + paymentId;
    }

    getStatusTag(payment) {
        if (payment.paymentSuccess && payment.policyGeneratedSuccess) {
            return <Tag color="success">Success</Tag>;
        } else if (payment.paymentSuccess && !payment.policyGeneratedSuccess) {
            return <Tag color="warning">Payment Success - Policy Not Generated</Tag>;
        } else if (!payment.paymentSuccess) {
            return <Tag color="error">Payment Failed</Tag>;
        } else {
            return <Tag color="default">Pending</Tag>;
        }
    }

    render() {
        const columns = [
            {
                title: 'Payment Ref',
                dataIndex: 'paymentRef',
                render: (paymentRef) => (
                    <Fragment key={1}>
                        <Paragraph className="text-muted p-0 mb-0">{paymentRef || 'N/A'}</Paragraph>
                    </Fragment>
                ),
            },
            {
                title: 'Email',
                dataIndex: 'email',
                render: (email, record) => (
                    <Fragment key={2}>
                        <Paragraph className="text-muted p-0 mb-0">
                            {email || record.user?.email || 'N/A'}
                        </Paragraph>
                    </Fragment>
                ),
            },
            {
                title: 'User Name',
                dataIndex: 'user',
                render: (user) => (
                    <Fragment key={3}>
                        <Paragraph className="text-muted p-0 mb-0">
                            {user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : 'N/A'}
                        </Paragraph>
                    </Fragment>
                ),
            },
            {
                title: 'Amount',
                dataIndex: 'amount',
                render: (amount) => (
                    <Fragment key={4}>
                        <Paragraph className="text-muted p-0 mb-0">
                            {amount ? `${amount.toFixed(2)}` : 'N/A'}
                        </Paragraph>
                    </Fragment>
                ),
            },
            {
                title: 'Payment Channel',
                dataIndex: 'paymentChannel',
                render: (paymentChannel) => (
                    <Fragment key={5}>
                        <Paragraph className="text-muted p-0 mb-0">{paymentChannel || 'N/A'}</Paragraph>
                    </Fragment>
                ),
            },
            {
                title: 'Status',
                dataIndex: 'id',
                render: (id, record) => <Fragment key={6}>{this.getStatusTag(record)}</Fragment>,
            },
            {
                title: 'Created Date',
                dataIndex: 'createdAt',
                render: (createdAt) => (
                    <Fragment key={7}>
                        <Paragraph className="text-muted p-0 mb-0">
                            {moment(createdAt).format('MM/DD/YYYY HH:mm')}
                        </Paragraph>
                    </Fragment>
                ),
            },
            {
                title: 'View More',
                dataIndex: 'id',
                render: (id) => (
                    <Fragment key={8}>
                        <Button
                            htmlType="button"
                            type="primary"
                            shape="circle"
                            onClick={() => this.navigateToPayment(id)}
                        >
                            <SearchOutlined />
                        </Button>
                    </Fragment>
                ),
            },
        ];

        return (
            <Layout className="dashboard payments">
                <AdminPortalHeader />
                <div className="m-2">
                    <Title level={2} className="text-green font-600 pt-3 ps-3 m-0">
                        Payments
                    </Title>
                    <Row gutter={15}>
                        <Col className="pt-3 px-3" xs={6} sm={6} md={6} lg={6} xl={6}>
                            <div className="filters-section">
                                <Title level={5}>Filters</Title>

                                <div className="mb-3">
                                    <label>Age Filter:</label>
                                    <Select
                                        className="full-width"
                                        value={this.state.selectedAge}
                                        onChange={this.onAgeChange}
                                    >
                                        <Option value="within7days">Within 7 Days</Option>
                                        <Option value="olderThan7days">Older Than 7 Days</Option>
                                    </Select>
                                </div>

                                <div className="mb-3">
                                    <label>Payment Status:</label>
                                    <Select
                                        className="full-width"
                                        value={this.state.selectedStatus}
                                        onChange={this.onStatusChange}
                                        allowClear
                                        placeholder="All"
                                    >
                                        <Option value="success">Success</Option>
                                        <Option value="paymentSuccess_policyNotGenerated">
                                            Payment Success - Policy Not Generated
                                        </Option>
                                        <Option value="paymentFailed">Payment Failed</Option>
                                        <Option value="paymentPending">Payment Pending</Option>
                                    </Select>
                                </div>

                                <div className="mb-3">
                                    <label>Payment Channel:</label>
                                    <Select
                                        className="full-width"
                                        value={this.state.selectedPaymentChannel}
                                        onChange={this.onPaymentChannelChange}
                                        allowClear
                                        placeholder="All"
                                    >
                                        <Option value="Monthly Installment - Tamara">
                                            Monthly Installment - Tamara
                                        </Option>
                                        <Option value="One Time">One Time</Option>
                                        <Option value="broker">Broker</Option>
                                        <Option value="Monthly Installment - Tamara - Broker">
                                            Monthly Installment - Tamara - Broker
                                        </Option>
                                        <Option value="One Time - Broker">One Time - Broker</Option>
                                    </Select>
                                </div>

                                <div className="mb-3">
                                    <label>Search by Email:</label>
                                    <Search
                                        placeholder="Enter email"
                                        allowClear
                                        enterButton="Search"
                                        value={this.state.searchEmail}
                                        onChange={(e) => this.setState({ searchEmail: e.target.value })}
                                        onSearch={this.onSearchEmail}
                                    />
                                </div>

                                <Button
                                    htmlType="button"
                                    className="full-width mt-3"
                                    onClick={this.onClearFilters}
                                >
                                    Clear All Filters
                                </Button>
                            </div>
                        </Col>
                        <Col className="pt-3 px-3" xs={18} sm={18} md={18} lg={18} xl={18}>
                            <Card
                                className="custom-shadow green"
                                title={
                                    <Title level={4} className="text-center text-white">
                                        Payments List
                                    </Title>
                                }
                            >
                                <div>
                                    <Table
                                        className="noborder"
                                        columns={columns}
                                        dataSource={this.state.payments}
                                        pagination={false}
                                        size="small"
                                        loading={this.state.loading}
                                        rowKey="id"
                                    />

                                    {this.state.totalRecs > 0 && (
                                        <div>
                                            <hr></hr>
                                            <Pagination
                                                current={this.state.currentPage}
                                                pageSize={this.state.pageSize}
                                                total={this.state.totalRecs}
                                                onChange={async (page) => await this.onPaginationChange(page)}
                                                showTotal={this.showTotal}
                                            />
                                        </div>
                                    )}
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </Layout>
        );
    }
}

export default AdminPayments;
